<template>
  <div id="img-container">
    <video
      class="img-fluid"
      src="../assets/videos/vap.mp4"
      autoplay
      loop
      muted
      defaultMuted
      playsinline
    ></video>
  </div>
  <!-- Slogan Old -->
  <!-- <div id="animation" class="container">
    <div id="img-container" ref="sloganImg">
      <video
        class="img-fluid"
        src="../assets/videos/story-2.mp4"
        autoplay
        loop
        muted
        defaultMuted
        playsinline
      ></video>
    </div>
  </div> -->
</template>

<script lang="ts" setup>
const sloganImg = ref();

const closeSlogan = () => {
  sloganImg.value.classList.add("slogan");
};

onMounted(() => {
  setTimeout(closeSlogan, 3800);
});
</script>

<style scoped>
#img-container {
  /* Slogan */
  /* height: 900px; */
  height: 95vh;
  /* transition: height 0.3s ease-out; */
  overflow: hidden;
  /* background: #d5d5d5; */
  background-color: black;
}

#teaser-vid {
  width: 100%;
  height: 100%;
}

.slogan {
  height: 0px !important;
  transition: height 0.3s ease-in-out;
}
</style>
